import { gql } from "apollo-angular";
import { LINK_FIELDS } from "./link";
import { ILLINKSnippet, INLNK } from "./template-nav-links";

export const  CBF = gql`
  fragment CBF on ContentBlock {
    header
    headerTag
    hTagId
    content
    buttonTitle
    buttonLink
    linkTarget
    jumpTarget
    buttonLink2 {
      ${ILLINKSnippet}
    }
    docLink {
      ...DOCLNK
    }
    rightRailLinksCollection (limit:10) {
      items {
        ...LINK_FIELDS
      }
    }
    listItemsCollection(limit: 10) {
      items {
        icon
        text
      }
    }
    statIcon
    faIcon
    imageAlignment
    image {
      url
      description
    }
    video {
      url
      description
    }
    videoYouTubeLink
    mediaImageLink
    mediaDatabaseColorLogo
    mediaCaptionHeading
    mediaCaptionContent
    mediaConfigs
    imageOverlayText
    disclaimer {
      disclaimer
    }
}
${INLNK}
${LINK_FIELDS}`;
